(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oferta-curso-365"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('offer-countdown-365')) {
    customElements.define('offer-countdown-365', class extends HTMLElement {
      connectedCallback() {
        // Esperar al contenido del elemento; también funciona al recargar secciones en el editor.
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearInterval(this.interval);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }
      initialize() {
        clearInterval(this.interval);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        this.timer = this.querySelector('[data-countdown]');
        this.clock = this.querySelector('[data-clock]');
        this.cta = this.querySelector('[data-cta]');
        this.todayLabel = this.querySelector('[data-today-label]');
        this.timeZone = 'America/New_York';
        try {
          const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (detected) this.timeZone = detected;
          this.dateFormatter = this.makeFormatter(this.timeZone);
        } catch (error) {
          this.timeZone = 'America/New_York';
          this.dateFormatter = this.makeFormatter(this.timeZone);
        }
        if (this.cta && !this.originalButton) {
          this.originalButton = {
            href: this.cta.getAttribute('href'),
            role: this.cta.getAttribute('role'),
            disabled: this.cta.getAttribute('aria-disabled'),
            label: this.cta.querySelector('[data-button-label]').textContent,
            iconHidden: this.cta.querySelector('[data-button-icon]').hidden
          };
        }
        this.timerEnabled = this.timer && this.dataset.timerEnabled === 'true';
        if (this.timer) this.timer.hidden = !this.timerEnabled;
        this.dayKey = null;
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
        this.onVisibility = () => { if (!document.hidden) this.tick(); };
        document.addEventListener('visibilitychange', this.onVisibility);
      }
      makeFormatter(timeZone) {
        return new Intl.DateTimeFormat('en-GB', {
          timeZone, calendar: 'gregory', numberingSystem: 'latn',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
      }
      dateParts(timestamp) {
        const result = {};
        for (const part of this.dateFormatter.formatToParts(new Date(timestamp))) {
          if (part.type !== 'literal') result[part.type] = Number(part.value);
        }
        return result;
      }
      dailyDeadline(parts) {
        // Convertir las 23:59 locales a un instante real, incluido el horario de verano.
        const target = Date.UTC(parts.year, parts.month - 1, parts.day, 23, 59, 0);
        let candidate = target;
        for (let i = 0; i < 4; i++) {
          const local = this.dateParts(candidate);
          const represented = Date.UTC(local.year, local.month - 1, local.day,
            local.hour, local.minute, local.second);
          const correction = target - represented;
          candidate += correction;
          if (correction === 0) break;
        }
        return candidate;
      }
      resetDailyOffer() {
        this.querySelector('[data-expired-message]').hidden = true;
        if (this.cta && this.originalButton) {
          for (const [attribute, value] of [
            ['href', this.originalButton.href],
            ['role', this.originalButton.role],
            ['aria-disabled', this.originalButton.disabled]
          ]) {
            if (value === null) this.cta.removeAttribute(attribute);
            else this.cta.setAttribute(attribute, value);
          }
          this.cta.querySelector('[data-button-label]').textContent = this.originalButton.label;
          this.cta.querySelector('[data-button-icon]').hidden = this.originalButton.iconHidden;
        }
      }
      tick() {
        const now = Date.now();
        const parts = this.dateParts(now);
        const dayKey = [parts.year, parts.month, parts.day].join('-');
        if (dayKey !== this.dayKey) {
          this.dayKey = dayKey;
          this.end = this.dailyDeadline(parts);
          const months = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN',
            'JUL', 'AGO', 'SEPT', 'OCT', 'NOV', 'DIC'];
          if (this.todayLabel) {
            this.todayLabel.textContent = 'SOLO POR HOY ' + parts.day + '/' + months[parts.month - 1];
          }
          this.resetDailyOffer();
          if (this.timerEnabled) {
            this.showDays = this.end - now >= 86400000;
            this.clock.classList.toggle('has-days', this.showDays);
            this.querySelector('[data-days-unit]').hidden = !this.showDays;
            this.querySelector('[data-days-colon]').hidden = !this.showDays;
          }
        }
        if (!this.timerEnabled) return;
        const total = Math.max(0, Math.ceil((this.end - now) / 1000));
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor(total / 3600) % 24,
          minutes: Math.floor(total / 60) % 60,
          seconds: total % 60
        };
        for (const [key, value] of Object.entries(values)) {
          const node = this.querySelector('[data-digit="' + key + '"]');
          const next = String(value).padStart(2, '0');
          if (node.textContent !== next) {
            node.classList.remove('is-changing');
            node.textContent = next;
            void node.offsetWidth;
            node.classList.add('is-changing');
          }
        }
        if (total === 0) {
          this.expire();
        }
      }
      expire() {
        this.querySelector('[data-expired-message]').hidden = false;
        if (this.dataset.disableExpired === 'true' && this.cta) {
          this.cta.removeAttribute('href');
          this.cta.setAttribute('role', 'link');
          this.cta.setAttribute('aria-disabled', 'true');
          this.cta.querySelector('[data-button-label]').textContent = this.dataset.expiredLabel;
          this.cta.querySelector('[data-button-icon]').hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
